const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsIndustria = { name: 'Indústria', pathName: null, action: 'industria' }

const offerMeta = {
  breadcrumbs: [
    breadcrumbsHome,
    breadcrumbsIndustria,
    {
      name: 'Ofertas de Trade',
      pathName: '/industria/ofertas-trade/propostas',
    },
    {
      name: 'Campanha',
      pathName: null,
    },
  ],
  title: 'Ofertas de Trade',
  permission: 'industry',
  pagePermission: 'industria/ofertas_trade',
  allowOnlyMercapromo: true,
  redirectAfterLogin: '/industria/ofertas-trade/propostas',
}

const smsMeta = {
  breadcrumbs: [
    breadcrumbsHome,
    breadcrumbsIndustria,
    {
      name: 'SMS de trade',
      pathName: '/industria/sms-trade',
    },
    {
      name: 'Campanha',
      pathName: null,
    },
  ],
  title: 'SMS de trade',
  permission: 'industry',
  pagePermission: 'industria/sms_trade',
  allowOnlyMercapromo: true,
  redirectAfterLogin: '/industria/sms-trade',
}

export default [
  {
    path: '/industria',
    component: () => import('@/modules/industria/views/pages/Industria.vue'),
    children: [
      {
        path: 'resultados-gerais',
        name: 'resultados-gerais',
        component: () => import('@/modules/industria/resultados-gerais/views/pages/GeneralResults.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'Resultados gerais',
              pathName: null,
            },
          ],
          title: 'Resultados gerais',
          permission: 'industry',
          allowOnlyMercapromo: true,
        },
      },

      {
        path: 'ofertas-trade',
        name: 'ofertas-trade',
        component: () => import('@/modules/industria/ofertas-trade/views/pages/Index.vue'),
        redirect: '/industria/ofertas-trade/propostas',
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'Ofertas de Trade',
              pathName: null,
            },
          ],
          title: 'Gestão de trades',
          permission: 'industry',
          pagePermission: 'industria/ofertas_trade',
          allowOnlyMercapromo: true,
        },
        children: [
          {
            path: 'propostas',
            name: 'ofertas-trade-propostas',
            component: () => import('@/modules/industria/ofertas-trade/views/pages/Propostas.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsIndustria,
                {
                  name: 'Ofertas de Trade',
                  pathName: null,
                },
              ],
              title: 'Propostas da indústria',
              permission: 'industry',
              pagePermission: 'industria/ofertas_trade',
              allowOnlyMercapromo: true,
            },
          },
          {
            path: 'aceitas',
            name: 'ofertas-trade-aceitas',
            component: () => import('@/modules/industria/ofertas-trade/views/pages/Aceitas.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsIndustria,
                {
                  name: 'Ofertas de Trade',
                  pathName: null,
                },
              ],
              title: 'Ofertas aceitas',
              permission: 'industry',
              pagePermission: 'industria/ofertas_trade',
              allowOnlyMercapromo: true,
            },
          },
          {
            path: 'historico',
            name: 'ofertas-trade-historico',
            component: () => import('@/modules/industria/ofertas-trade/views/pages/Historico.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsIndustria,
                {
                  name: 'Ofertas de Trade',
                  pathName: null,
                },
              ],
              title: 'Histórico de ofertas',
              permission: 'industry',
              pagePermission: 'industria/ofertas_trade',
              allowOnlyMercapromo: true,
            },
          },
        ],
      },
      {
        path: 'ofertas-trade/resultados/:id',
        name: 'ofertas-trade-resultado',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/Results.vue'),
        meta: offerMeta,
      },
      {
        path: 'ofertas-trade/resultados-mercapromo/:id',
        name: 'ofertas-trade-resultado-mercapromo',
        component: () => import('@/modules/industria/ofertas-trade/views/pages/ResultsMercapromo.vue'),
        meta: offerMeta,
      },
      {
        path: 'ofertas-trade/historico-consultas/:id',
        name: 'ofertas-trade-historico-consultas',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/ConsumedSalesSession.vue'),
        meta: offerMeta,
      },
      {
        path: 'ofertas-trade/visualizar/:id',
        name: 'ofertas-trade-visualizar',
        component: () => import('@/modules/industria/ofertas-trade/views/pages/ViewOfferTrade.vue'),
        meta: offerMeta,
      },

      {
        path: 'sms-trade',
        name: 'sms-trade',
        component: () => import('@/modules/industria/sms-trade/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'SMS de trade',
              pathName: null,
            },
          ],
          title: 'SMS de trade',
          permission: 'industry',
          pagePermission: 'industria/sms_trade',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'sms-trade/editar/:id',
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Campaign.vue'),
        meta: smsMeta,
      },
      {
        path: 'sms-trade/resultados/:id',
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Results.vue'),
        meta: smsMeta,
      },
      {
        path: 'cashback-trade',
        component: () => import('@/modules/industria/cashback/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'Cashback de trade',
              pathName: '/industria/cashback-trade',
            },
          ],
          title: 'Cashback de trade',
          permission: 'industry',
          pagePermission: 'industria/cashback_trade',
          allowOnlyMercapromo: true,
          redirectAfterLogin: '/industria/cashback-trade',
        },
      },
    ],
  },
]
